import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

const LinkHref = ({
  link,
  text,
  id,
  className,
  activeClassName,
  partiallyActive,
  openNew,
}) => {
  const isHref = Boolean(link.startsWith('http'));

  if (isHref) {
    if (openNew) {
      return (
        <a href={link} className={className} data-id={id}
          target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      );
    } else {
      return (
        <a href={link} title={text} className={className} data-id={id}>
          {text}
        </a>
      );
    }
  } else if (!isHref) {
    if (openNew) {
      return (
        <a href={link} className={className} data-id={id}
          target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      );
    } else {
      return (
        <Link
          to={link}
          activeClassName={activeClassName}
          className={className}
          data-id={id}
          partiallyActive={partiallyActive}
        >
          {text}
        </Link>
      );
    }
    
  } else {
    return (
      <a href={link} className={className} data-id={id}>
        {text}
      </a>
    );
  }
};

LinkHref.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  partiallyActive: PropTypes.bool,
  openNew: PropTypes.bool,
};
LinkHref.defaultProps = {
  openNew: false,
  partiallyActive: false,
};

export default LinkHref;
